module.exports = __webpack_public_path__ + "img/Posture_Perfect.e4332128.png";